import { render, staticRenderFns } from "./Annexes.vue?vue&type=template&id=4a5ea8f3"
import script from "./Annexes.vue?vue&type=script&lang=js"
export * from "./Annexes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports